// https://stackoverflow.com/a/43519507/10043695
// Decator to transform null values to undefined to enable default values
const N =
	(f) =>
	(...a) =>
		f(...a.map((v) => (v === null ? undefined : v)));

export default N;
